module.exports = __webpack_public_path__ + "assets/img/office-building-szepvolgyi-1280.729b44cf.webp";